/* eslint-disable max-len */
import React from 'react';
import { Typography } from '@one-thd/sui-atomic-components';
import classNames from 'classnames';
import {
  any,
  bool as boolType,
  string as stringType
} from 'prop-types';
import VisualTabs from './VisualTabs';

const buildIRGTitle = (brandname) => {
  return brandname !== null ? ('Shop This Collection from ' + brandname) : 'More from This Brand';
};

const IRGUtils = (props) => {
  const {
    products, categories, isCategoryTab, isIRG, pullFilteredData
  } = props;

  return (
    <>
      {isCategoryTab ? (
        <div className="sui-py-4">
          <Typography variant="h2">{buildIRGTitle(products[0]?.product?.identifiers?.brandName)}</Typography>
        </div>
      ) : (
        <div className="sui-py-4">
          <Typography variant="h2">You Might Also Need</Typography>
        </div>
      )}
      {isCategoryTab && categories?.length > 1 && (
        <div className={classNames('sui-pb-4')}>
          <VisualTabs products={products} isIRG={isIRG} categories={categories} filterItemIds={pullFilteredData} />
        </div>
      )}
    </>
  );
};

IRGUtils.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  products: any,
  // eslint-disable-next-line react/forbid-prop-types
  categories: any,
  isCategoryTab: boolType,
  isIRG: boolType,
  // eslint-disable-next-line react/forbid-prop-types
  pullFilteredData: any
};

IRGUtils.defaultProps = {
  products: [],
  categories: [],
  isCategoryTab: false,
  isIRG: true,
  pullFilteredData: ''
};

export { IRGUtils };